module.exports = __webpack_public_path__ + "img/banner3_1_en.71543dc3.png";